import { createSlice } from '@reduxjs/toolkit';

import actions from './session.actions';

import type { Session } from './session.types';

const initialState: Partial<Session> = {};

const session = createSlice({
  name: 'session',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder.addCase(actions.getSession.fulfilled, (state, { payload }) => {
      return payload;
    });
  },
});

export default session;
